<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h3 class="text-center">Opret ny bruger</h3>
      <img
        id="profile-img"
        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
        class="profile-img-card mt-3"
      />
      <form @submit.prevent="handleRegister">
        <div class="form-group">
          <label for="firstname">Fornavn</label>
          <input
            name="firstname"
            autofocus
            id="firstname"
            type="text"
            class="form-control"
            v-model="firstname"
          />
        </div>
        <div class="form-group">
          <label for="lastname">Efternavn</label>
          <input
            name="lastname"
            id="lastname"
            type="text"
            class="form-control"
            v-model="lastname"
          />
        </div>
        <div class="form-group">
          <label for="email">E-mail</label>
          <input
            name="email"
            id="email"
            type="email"
            class="form-control"
            v-model="email"
          />
        </div>
        <div class="form-group">
          <label for="password">Vælg kommune</label>
          <select
            class="form-control"
            id="municipalityCode"
            name="municipalityCode"
            v-model="municipalityCode"
          >
            <option
              v-for="municipality in municipalities"
              v-bind:key="municipality.municipalityCode"
              v-bind:value="municipality.municipalityCode"
            >
              {{ municipality.name }}
            </option>
          </select>
        </div>

        <div class="form-group mt-3">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            <span>Opret bruger</span>
          </button>
        </div>

        <div class="form-group mt-3">
          <router-link to="/login">Jeg har allerede et login</router-link><br />
        </div>

        <div class="form-group mt-3">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AuthService from '../services/auth.service';

export default {
  name: 'Register',
  components: {},
  data() {
    return {
      firstname: '',
      lastname: '',
      municipalityCode: '',
      email: '',
      loading: false,
      message: '',
      municipalities: [
        { name: 'Andet', code: '' },
        { name: 'Albertslund Kommune', code: '0165' },
        { name: 'Allerød Kommune', code: '0201' },
        { name: 'Assens Kommune', code: '0420' },
        { name: 'Ballerup Kommune', code: '0151' },
        { name: 'Billund Kommune', code: '0530' },
        { name: 'Bornholm Kommune', code: '0400' },
        { name: 'Brøndby Kommune', code: '0153' },
        { name: 'Brønderslev Kommune', code: '0810' },
        { name: 'Christiansø Kommune', code: '0411' },
        { name: 'Dragør Kommune', code: '0155' },
        { name: 'Egedal Kommune', code: '0240' },
        { name: 'Esbjerg Kommune', code: '0561' },
        { name: 'Fanø Kommune', code: '0563' },
        { name: 'Favrskov Kommune', code: '0710' },
        { name: 'Faxe Kommune', code: '0320' },
        { name: 'Fredensborg Kommune', code: '0210' },
        { name: 'Fredericia Kommune', code: '0607' },
        { name: 'Frederiksberg Kommune', code: '0147' },
        { name: 'Frederikshavn Kommune', code: '0813' },
        { name: 'Frederikssund Kommune', code: '0250' },
        { name: 'Furesø Kommune', code: '0190' },
        { name: 'Faaborg-Midtfyn Kommune', code: '0430' },
        { name: 'Gentofte Kommune', code: '0157' },
        { name: 'Gladsaxe Kommune', code: '0159' },
        { name: 'Glostrup Kommune', code: '0161' },
        { name: 'Greve Kommune', code: '0253' },
        { name: 'Gribskov Kommune', code: '0270' },
        { name: 'Guldborgsund Kommune', code: '0376' },
        { name: 'Haderslev Kommune', code: '0510' },
        { name: 'Halsnæs Kommune', code: '0260' },
        { name: 'Hedensted Kommune', code: '0766' },
        { name: 'Helsingør Kommune', code: '0217' },
        { name: 'Herlev Kommune', code: '0163' },
        { name: 'Herning Kommune', code: '0657' },
        { name: 'Hillerød Kommune', code: '0219' },
        { name: 'Hjørring Kommune', code: '0860' },
        { name: 'Holbæk Kommune', code: '0316' },
        { name: 'Holstebro Kommune', code: '0661' },
        { name: 'Horsens Kommune', code: '0615' },
        { name: 'Hvidovre Kommune', code: '0167' },
        { name: 'Høje-Taastrup Kommune', code: '0169' },
        { name: 'Hørsholm Kommune', code: '0223' },
        { name: 'Ikast-Brande Kommune', code: '0756' },
        { name: 'Ishøj Kommune', code: '0183' },
        { name: 'Jammerbugt Kommune', code: '0849' },
        { name: 'Kalundborg Kommune', code: '0326' },
        { name: 'Kerteminde Kommune', code: '0440' },
        { name: 'Kolding Kommune', code: '0621' },
        { name: 'Københavns Kommune', code: '0101' },
        { name: 'Køge Kommune', code: '0259' },
        { name: 'Langeland Kommune', code: '0482' },
        { name: 'Lejre Kommune', code: '0350' },
        { name: 'Lemvig Kommune', code: '0665' },
        { name: 'Lolland Kommune', code: '0360' },
        { name: 'Lyngby-Taarbæk Kommune', code: '0173' },
        { name: 'Læsø Kommune', code: '0825' },
        { name: 'Mariagerfjord Kommune', code: '0846' },
        { name: 'Middelfart Kommune', code: '0410' },
        { name: 'Morsø Kommune', code: '0773' },
        { name: 'Norddjurs Kommune', code: '0707' },
        { name: 'Nordfyns Kommune', code: '0480' },
        { name: 'Nyborg Kommune', code: '0450' },
        { name: 'Næstved Kommune', code: '0370' },
        { name: 'Odder Kommune', code: '0727' },
        { name: 'Odense Kommune', code: '0461' },
        { name: 'Odsherred Kommune', code: '0306' },
        { name: 'Randers Kommune', code: '0730' },
        { name: 'Rebild Kommune', code: '0840' },
        { name: 'Ringkøbing-Skjern Kommune', code: '0760' },
        { name: 'Ringsted Kommune', code: '0329' },
        { name: 'Roskilde Kommune', code: '0265' },
        { name: 'Rudersdal Kommune', code: '0230' },
        { name: 'Rødovre Kommune', code: '0175' },
        { name: 'Samsø Kommune', code: '0741' },
        { name: 'Silkeborg Kommune', code: '0740' },
        { name: 'Skanderborg Kommune', code: '0746' },
        { name: 'Skive Kommune', code: '0779' },
        { name: 'Slagelse Kommune', code: '0330' },
        { name: 'Solrød Kommune', code: '0269' },
        { name: 'Sorø Kommune', code: '0340' },
        { name: 'Stevns Kommune', code: '0336' },
        { name: 'Struer Kommune', code: '0671' },
        { name: 'Svendborg Kommune', code: '0479' },
        { name: 'Syddjurs Kommune', code: '0706' },
        { name: 'Sønderborg Kommune', code: '0540' },
        { name: 'Thisted Kommune', code: '0787' },
        { name: 'Tønder Kommune', code: '0550' },
        { name: 'Tårnby Kommune', code: '0185' },
        { name: 'Vallensbæk Kommune', code: '0187' },
        { name: 'Varde Kommune', code: '0573' },
        { name: 'Vejen Kommune', code: '0575' },
        { name: 'Vejle Kommune', code: '0630' },
        { name: 'Vesthimmerlands Kommune', code: '0820' },
        { name: 'Viborg Kommune', code: '0791' },
        { name: 'Vordingborg Kommune', code: '0390' },
        { name: 'Ærø Kommune', code: '0492' },
        { name: 'Aabenraa Kommune', code: '0580' },
        { name: 'Aalborg Kommune', code: '0851' },
        { name: 'Aarhus Kommune', code: '0751' },
      ],
    };
  },
  created() {},
  methods: {
    handleRegister() {
      this.loading = true;

      AuthService.register(
        this.firstname,
        this.lastname,
        this.email,
        this.municipalityCode
      )
        .then(() => {
          window.location = '/';
        })
        .catch(() => {
          this.loading = false;
          this.message = 'Der opstod en fejl';
        });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
